import { render, staticRenderFns } from "./sidebar-pricing.vue?vue&type=template&id=7163eb0e&scoped=true&"
import script from "./sidebar-pricing.vue?vue&type=script&lang=js&"
export * from "./sidebar-pricing.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-pricing.vue?vue&type=style&index=0&id=7163eb0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163eb0e",
  null
  
)

export default component.exports